/**
 * Brief (Envelope) – Frontend Toggle Logic
 *
 * Opens the mail envelope on click.
 * In inline mode the letter height and wrapper min-height are adjusted
 * dynamically so the content is fully visible.
 */

if (typeof window.toggleZggMail !== 'function') {
    window.toggleZggMail = function (wrapper) {
        if (!wrapper.classList.contains('is-open')) {
            wrapper.classList.add('is-open');
            if (wrapper.classList.contains('is-inline')) {
                const letter = wrapper.querySelector('.mail-letter');
                const content = wrapper.querySelector('.mail-letter-content');
                const envelope = wrapper.querySelector('.mail-envelope');

                if (!letter || !content || !envelope) {
                    return;
                }

                const contentHeight = content.scrollHeight;
                letter.style.height = (contentHeight + 2) + 'px';

                const envelopeHeight = envelope.offsetHeight;
                const envelopeShift = Math.min(160, window.innerWidth * 0.36);
                const letterShift = Math.min(120, window.innerWidth * 0.27);
                const letterTop = envelopeShift + (envelopeHeight * 0.94) - contentHeight - letterShift;
                const letterBottom = envelopeShift + (envelopeHeight * 0.94) - letterShift;
                const topOverflow = Math.max(0, -letterTop);
                const bottomOverflow = Math.max(envelopeShift, letterBottom - envelopeHeight);
                const visualHeight = envelopeHeight + (2 * Math.max(topOverflow, bottomOverflow));

                wrapper.style.minHeight = Math.max(450, Math.ceil(visualHeight)) + 'px';
            }
        }
    }
}
